import { PrinterOutlined } from "@ant-design/icons";
import { Button, Switch, Tag } from "antd";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { $t } from "~/i18n.js";

import { updateIfNeeded } from "~/lib/helpers.js";
import { toLocaleDate } from "~/lib/localize.js";
import {
  aanmeldingenActions,
  daysActions,
  flightsActions,
} from "~/redux/actions.js";

import { Loader } from "~/components/loader/loader.jsx";
import { PrintRow } from "./components/printRow.jsx";

import { VoucherCard } from "~/components/voucher/VoucherCard.jsx";
import { clubHasFinance } from "~/featureMatrix.jsx";
import { api } from "~/lib/api.js";
import "./aanmeldLijst.css";
import { ECETLazy } from "~/components/topmeteo/ECETLazy.jsx";

export const PrintAanmeldLijstComponent = ({
  match,
  aanmeldingen,
  flights,
  club,
  days,
  getBaseData,
  getAanmeldingen,
  getAllDays,
  openDay,
}) => {
  let group_name_lookup = flights.group_name_lookup;

  // setup base data
  useEffect(() => {
    updateIfNeeded(flights.lastUpdatedBaseData, getBaseData);
  }, [flights.lastUpdatedBaseData, getBaseData]);
  useEffect(() => {
    updateIfNeeded(
      days.lastUpdated,
      getAllDays,
      () => days.lastUpdated && openDay(match.params.id),
    );
  }, [days.lastUpdated, getAllDays, match.params.id, openDay]);
  useEffect(() => {
    getAanmeldingen({ dag_id: match.params.id });
  }, [match.params.id, getAanmeldingen]);

  const types = flights.club_kisten.reduce((all, kist) => {
    if (!all[kist.type]) all[kist.type] = kist.type_group;
    return all;
  }, {});

  const [sorted, setSorted] = useState(true);
  const [viewRegistrationLists, setViewRegistrationLists] = useState(true);

  const [showAllUsers, setShowAllUsers] = useState(false);
  const limit_signup_time = club.limit_signup_time;

  const lijst_later_aankomen = aanmeldingen.aanmeldingen.filter((a) => !!a.van);
  const laterAankomendeGebruikers = lijst_later_aankomen.length;

  let lijst_aanmeldingen = aanmeldingen.aanmeldingen.filter((a) => {
    if (!a.aangemeld) return false;
    if (limit_signup_time && !showAllUsers && a.van) return false;
    return true;
  });
  lijst_aanmeldingen.sort((a, b) => a.order - b.order);

  const registration_lists = aanmeldingen?.registration_lists;

  const all_vliegers = [];
  const niet_vliegend_lijst = [];
  const gast_vliegers_lijst = [];
  const dbo_lijst = [];
  const solo_lijst = [];
  const brevet_lijst = [];
  const prive_lijst = [];

  const userDienstLookup = aanmeldingen.diensten.reduce((all, dienst) => {
    if (!all[dienst.user_id]) all[dienst.user_id] = [];
    all[dienst.user_id].push(dienst);
    return all;
  }, {});

  let squeeze_left = false;
  let squeeze_right = false;

  // in case of vouchers we download them here
  const has_finance = clubHasFinance();
  const [vouchers, setVouchers] = useState([]);
  const getVouchers = async (date) => {
    let url = `financial/vouchers.json?page=${1}&open=1&only=1&date=${date}`;
    const data = await api.get(url);

    if (data) {
      setVouchers(data.results);
    }
  };
  useEffect(() => {
    if (has_finance && days.activeDay.is_vliegend) {
      getVouchers(days.activeDay.datum);
    }
  }, [has_finance, days.activeDay.datum, days.activeDay.is_vliegend]);

  lijst_aanmeldingen.forEach((v) => {
    if (viewRegistrationLists && registration_lists?.length > 0) {
      // check if v in any of the registration lists, if so, we skip the overal view
      const in_registration_list = registration_lists.some((list) =>
        list.registrations.some((reg) => reg.user_id === v.vlieger.id),
      );
      if (in_registration_list) {
        return;
      }
    }

    all_vliegers.push(v);

    if (
      v.vlieger &&
      v.vlieger.group_keys &&
      v.vlieger.group_keys?.includes("niet_vliegend")
    ) {
      niet_vliegend_lijst.push(v);
    } else if (
      v.vlieger &&
      v.vlieger.group_keys &&
      v.vlieger.group_keys?.includes("gastvlieger")
    ) {
      gast_vliegers_lijst.push(v);
    } else if (
      v.vlieger &&
      v.vlieger.group_keys &&
      v.vlieger.group_keys?.includes("solist")
    ) {
      solo_lijst.push(v);
    } else if (
      v.vlieger &&
      v.vlieger.group_keys &&
      v.vlieger.group_keys?.includes("dbo")
    ) {
      dbo_lijst.push(v);
    } else if (v.kist && v.kist.includes("privé")) {
      prive_lijst.push(v);
    } else {
      brevet_lijst.push(v);
    }
  });

  if (sorted) {
    // determine squeeze left/right
    squeeze_left =
      dbo_lijst.length +
        solo_lijst.length +
        gast_vliegers_lijst.length +
        niet_vliegend_lijst.length >
      10;
    squeeze_right = brevet_lijst.length + prive_lijst.length > 10;
  }

  if (days.activeDay.datum && document)
    document.title = `Aanmeldlijst_${days.activeDay.datum}`;

  if (!days.activeDay.datum || flights.isPending || days.isPending)
    return <Loader />;

  return (
    <div className="AanmeldPrintLijst">
      <div
        className="row spacer"
        style={{ alignItems: "center", position: "absolute", marginLeft: 12 }}
      >
        {!days.activeDay.gaat_door && (
          <Tag style={{ marginRight: 6 }} color="red">
            {$t("Geannuleerd")}
          </Tag>
        )}
        <p>
          <span className="bold">
            {toLocaleDate(new Date(days.activeDay.datum), {
              weekday: "short",
              year: "numeric",
              month: "short",
              day: "numeric",
            })}{" "}
            - {days.activeDay.type_dag}
            {days.activeDay.titel &&
              days.activeDay.titel.length > 0 &&
              ": " + days.activeDay.titel}
          </span>
          <br />
          {$t("briefing om")} {days.activeDay.briefing_tijd || "??"}{" "}
          {$t("vanaf")} {days.activeDay.vertrek_vliegveld},{" "}
          {lijst_aanmeldingen.length} {$t("aanmeldingen")}
          {club.vliegveld_icao === days.activeDay.vertrek_vliegveld && (
            <span style={{ marginLeft: 6 }}>
              <ECETLazy
                date={days.activeDay.datum}
                longitude={club.vliegveld_lon}
                latitude={club.vliegveld_lat}
                country={club.country}
              />
            </span>
          )}
        </p>

        <div className="row" style={{ alignItems: "center", marginLeft: 24 }}>
          {registration_lists?.length > 0 && (
            <p className="noprint small" style={{ marginRight: 12 }}>
              {$t("Registratie lijsten")}:{" "}
              <Switch
                size="small"
                checked={viewRegistrationLists}
                onChange={(checked) => setViewRegistrationLists(checked)}
              />
            </p>
          )}

          <p className="noprint small" style={{ marginRight: 12 }}>
            {$t("Gesorteerd")}:{" "}
            <Switch
              size="small"
              checked={sorted}
              onChange={(checked) => setSorted(checked)}
            />
          </p>

          {limit_signup_time && laterAankomendeGebruikers > 0 && (
            <p className="noprint small" style={{ marginRight: 12 }}>
              {$t("Gebruikers die later aankomen")} ({laterAankomendeGebruikers}
              ):{" "}
              <Switch
                size="small"
                checked={showAllUsers}
                onChange={(checked) => setShowAllUsers(checked)}
              />
            </p>
          )}

          <Button
            className="noprint"
            type="primary"
            icon={<PrinterOutlined />}
            onClick={() => window.print()}
          >
            {$t("Print")}
          </Button>
        </div>
      </div>

      {!sorted && (
        <div className="column" style={{ alignItems: "flex-start" }}>
          <div style={{ marginTop: 65 }}>
            {all_vliegers.map((aanmelding, key) =>
              PrintRow({
                groups_aanmeld: club.groups_aanmeld,
                a: aanmelding,
                key: key,
                types: types,
                squeeze: squeeze_right,
                skipLabels: false,
                group_name_lookup: group_name_lookup,
                userDienstLookup: userDienstLookup,
              }),
            )}

            {viewRegistrationLists && (
              <div className="column" style={{ alignItems: "flex-start" }}>
                {registration_lists.map((list, idx) => (
                  <div
                    key={idx}
                    style={{
                      marginTop: 4,
                      borderTop: "1px solid #ccc",
                      paddingTop: 8,
                    }}
                  >
                    <p
                      className="bold"
                      style={{ marginBottom: 6, fontSize: 12 }}
                    >
                      {list.name}
                    </p>
                    {list.registrations.map((reg, key) => {
                      if (reg.is_waitlist) return null;
                      const aanmelding = lijst_aanmeldingen.find(
                        (a) => a.vlieger.id === reg.user_id,
                      );
                      if (aanmelding) {
                        return PrintRow({
                          groups_aanmeld: club.groups_aanmeld,
                          a: aanmelding,
                          key: key,
                          types: types,
                          squeeze: true,
                          skipLabels: false,
                          group_name_lookup: group_name_lookup,
                          niet_vliegend: false,
                          userDienstLookup: userDienstLookup,
                        });
                      } else {
                        return null;
                      }
                    })}
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      )}

      {sorted && (
        <div className="row" style={{ alignItems: "flex-start" }}>
          <div style={{ flex: "50%", marginTop: 65 }}>
            {dbo_lijst.length > 0 && (
              <div>
                {dbo_lijst.map((aanmelding, key) =>
                  PrintRow({
                    groups_aanmeld: club.groups_aanmeld,
                    a: aanmelding,
                    key: key,
                    types: types,
                    squeeze: squeeze_left,
                    skipLabels: false,
                    group_name_lookup: group_name_lookup,
                    userDienstLookup: userDienstLookup,
                  }),
                )}
              </div>
            )}
            {solo_lijst.length > 0 && (
              <div className="printList">
                {solo_lijst.map((aanmelding, key) =>
                  PrintRow({
                    groups_aanmeld: club.groups_aanmeld,
                    a: aanmelding,
                    key: key,
                    types: types,
                    squeeze: squeeze_left,
                    skipLabels: false,
                    group_name_lookup: group_name_lookup,
                    userDienstLookup: userDienstLookup,
                  }),
                )}
              </div>
            )}

            {viewRegistrationLists && (
              <div className="column" style={{ alignItems: "flex-start" }}>
                {registration_lists.map((list, idx) => (
                  <div
                    className="column"
                    key={idx}
                    style={{
                      alignItems: "flex-start",
                      marginTop: 4,
                      borderTop: "1px solid #ccc",
                      paddingTop: 8,
                    }}
                  >
                    <p
                      className="bold"
                      style={{ marginBottom: 6, fontSize: 12 }}
                    >
                      {list.name}
                    </p>
                    {list.registrations.map((reg, key) => {
                      if (reg.is_waitlist) return null;
                      const aanmelding = lijst_aanmeldingen.find(
                        (a) => a.vlieger.id === reg.user_id,
                      );
                      if (aanmelding) {
                        return PrintRow({
                          groups_aanmeld: club.groups_aanmeld,
                          a: aanmelding,
                          key: key,
                          types: types,
                          squeeze: true,
                          skipLabels: false,
                          group_name_lookup: group_name_lookup,
                          niet_vliegend: false,
                          userDienstLookup: userDienstLookup,
                        });
                      } else {
                        return null;
                      }
                    })}
                  </div>
                ))}
              </div>
            )}

            {gast_vliegers_lijst.length > 0 && (
              <div className="printList">
                {gast_vliegers_lijst.map((aanmelding, key) =>
                  PrintRow({
                    groups_aanmeld: club.groups_aanmeld,
                    a: aanmelding,
                    key: key,
                    types: types,
                    squeeze: squeeze_left,
                    skipLabels: false,
                    group_name_lookup: group_name_lookup,
                    userDienstLookup: userDienstLookup,
                  }),
                )}
              </div>
            )}

            {niet_vliegend_lijst.length > 0 && (
              <div className="printList">
                {niet_vliegend_lijst.map((aanmelding, key) =>
                  PrintRow({
                    groups_aanmeld: club.groups_aanmeld,
                    a: aanmelding,
                    key: key,
                    types: types,
                    squeeze: squeeze_left,
                    skipLabels: true,
                    group_name_lookup: group_name_lookup,
                    niet_vliegend: true,
                    userDienstLookup: userDienstLookup,
                  }),
                )}
              </div>
            )}

            <VoucherCard vouchers={vouchers} />
          </div>

          <div
            style={{
              flex: "50%",
              marginTop: brevet_lijst.length > 15 ? 10 : 65,
            }}
          >
            <div>
              {brevet_lijst.map((aanmelding, key) =>
                PrintRow({
                  groups_aanmeld: club.groups_aanmeld,
                  a: aanmelding,
                  key: key,
                  types: types,
                  squeeze: squeeze_left,
                  skipLabels: false,
                  group_name_lookup: group_name_lookup,
                  userDienstLookup: userDienstLookup,
                }),
              )}
            </div>
            {prive_lijst.length > 0 && (
              <div className="printList">
                {prive_lijst.map((aanmelding, key) =>
                  PrintRow({
                    groups_aanmeld: club.groups_aanmeld,
                    a: aanmelding,
                    key: key,
                    types: types,
                    squeeze: squeeze_left,
                    skipLabels: true,
                    group_name_lookup: group_name_lookup,
                    userDienstLookup: userDienstLookup,
                  }),
                )}
              </div>
            )}

            {limit_signup_time && !showAllUsers && lijst_later_aankomen.length > 0 && (
              <div className="printList">
                {lijst_later_aankomen.sort((a, b) => a.van.localeCompare(b.van)).map((a, key) => (
                  <div key={key} className="record squeeze">
                    <div className="vlieger row">
                      <Tag
                        className="transparent gray"
                        style={{ marginRight: 18 }}
                      >
                        +{a.van}
                      </Tag>
                      <p className="name bold">{a.vlieger.name}</p>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({
  aanmeldingen: state.aanmeldingen,
  days: state.days,
  flights: state.flights,
  club: state.persist.club,
  profile: state.persist.profile,
  lastUpdated: state.materiaal.lastUpdated,
});

const mapDispatchToProps = (dispatch) => {
  return {
    getBaseData: (d) => dispatch(flightsActions.getBaseData(d)),
    openDay: (d) => dispatch(daysActions.openDay(d)),
    getAanmeldingen: (d) => dispatch(aanmeldingenActions.getAanmeldingen(d)),
    getAllDays: (d) => dispatch(daysActions.getAllDays(d)),
  };
};

export const PrintAanmeldLijstPagina = connect(
  mapStateToProps,
  mapDispatchToProps,
)(PrintAanmeldLijstComponent);
